import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  return (
    <div className="not-found">
      <div className="content">
        <h1>404</h1>
        <h2>ページが見つかりません</h2>
        <p>お探しのページは存在しないか、移動または削除された可能性があります。</p>
        <Link to="/" className="back-link">トップページに戻る</Link>
      </div>
    </div>
  );
}

export default NotFound; 